// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ehod","content":"styles_content__2gcCR"};